import {useState, useEffect} from 'react';
import { v4 as uuidv4 } from 'uuid';
import { createGlobalStyle } from 'styled-components';
import './Fetched.scss';

// let x = ...
function titleCase(str) {
  return str.toLowerCase().split(' ').map(function(word) {
    return (word.charAt(0).toUpperCase() + word.slice(1));
  }).join(' ');
}

const Fetched = ({ submitting }) => {
  const submittedFood = titleCase(submitting.food);
  const submittedTown = titleCase(submitting.town);

  const [isLoading, setIsLoading] = useState(true);
  const [isUndefined, setIsUndefined] = useState(false);
  const [dataFromYelp, setDataFromYelp] = useState([]);
  const [isFetch, setIsFetch] = useState(false);

	useEffect(() => {
    const fetchingYelpFx = async () => {
      try {
        setIsLoading(true);
        setIsUndefined(false);
        setDataFromYelp([]);
        setIsFetch(false)
        // submitting.town !== undefined
        if (
          //(submitting.food !== '' && submitting.town !== '') ||
          //(submitting.town !== undefined)
          (submitting.food !== '' || submitting.food !== undefined) &&
          (submitting.town !== '' || submitting.town !== undefined)
        ) {
          //console.log(submitting.food.length);
          //console.log(submitting.town.length);
          const raw_data = await fetch('/api/yelp');
          const json_data = await raw_data.json();
          //console.log(json_data.businesses);
          if (json_data.businesses === undefined) {
            setIsUndefined(true);
          }
          if (json_data.businesses !== undefined) {
            setDataFromYelp(json_data.businesses);
          }
          //setDataFromYelp(json_data.businesses);
          if (json_data.businesses.length > 0) {
            setIsLoading(false);
          }
          if (json_data.businesses.length === 0) {
            setIsFetch(true);
          }
        }
      } catch(err) {
        console.error(err);
      }
    };
    fetchingYelpFx();
  }, [submitting]);

  const BodyGradient = createGlobalStyle`
    body {
      height: ${props => (props.fullHeight ? '100vh' : '100%')};
    }
  `

  const businesses = dataFromYelp.map((i) => {

    const location = i.location.display_address.map((item) => {
      return (
        <p className="address" key={uuidv4()}>{item}</p>
      )
    });

    let all_cuisines = 0;
    const categories = i.categories.map((ii) => {
      all_cuisines++;
        return (
          <p key={uuidv4()} className="one-cuisine">
            {ii.title.toLowerCase()}{all_cuisines === i.categories.length ? '.' : ','}
          </p>
        )
    });

    return (
      <div key={uuidv4()} className="one-single-record">
        <img src={i.image_url} alt=""/>
        <div className="one-single-record-data">
          <p>{i.name}</p>
          <p>ratings: <span className="ratings"><span className="bold-700">{i.rating}</span>/5</span> ({i.review_count} {i.review_count === 1 ? 'review' : 'reviews'})</p>
          <p className="bold-500">address:</p>
          {location}
          <div className="cuisines">
            <p className="bold-500">specialties:&nbsp;</p>
            <div className="all-cuisines">{categories}</div>
          </div>
        </div>
      </div>
    )

  });

	return (
		<div className="Fetched">

      {isLoading === true  
        ? <BodyGradient fullHeight/>  
        : <BodyGradient/>
      }

      {
        (isLoading === false && isUndefined === false)
        &&
        <div className="fetch-yes-info">
          <p>You are digging for <span>{submittedFood.toLowerCase()}</span> in <span>{submittedTown}</span>, here we go:</p>
          <p className="yelp-api-info">&#40;Yelp API's limitation is up to 20 records&#41;</p>
        </div>
      }

      {
        (isFetch === true || isUndefined === true)
        &&
        <div className="fetch-no-info">
          <p className="no-fetch">Looking for <span>{submittedFood.toLowerCase()}</span> in <span>{submittedTown}</span>, huh?<br />Check your spelling and try again, or search for something else!</p>
        </div>
      }
      
			{businesses}

		</div>
	)
	
};

export default Fetched;
